import { render, staticRenderFns } from "./ChickList.vue?vue&type=template&id=5cc026b7&scoped=true&"
import script from "./ChickList.vue?vue&type=script&lang=js&"
export * from "./ChickList.vue?vue&type=script&lang=js&"
import style0 from "./ChickList.vue?vue&type=style&index=0&id=5cc026b7&lang=scss&scoped=true&"
import style1 from "./ChickList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc026b7",
  null
  
)

export default component.exports